import block from 'propmods';
import React, { FC } from 'react';
import SettingsIcon from './settings.svg';
import { routes } from '../../lib/routes';
import './UserSettingsPopup.scss';
import Link from '../Link/Link';

const b = block('UserSettingsPopup');

interface Props {
    padRight?: boolean;
}

const UserSettings: FC<Props> = ({ padRight }) => {
    return (
        <Link to={routes.app.settings()} {...b('settings-button', { 'pad-right': padRight })}>
            <SettingsIcon />
        </Link>
    );
};

export default UserSettings;
